import { createRoot } from "react-dom/client";
import { App } from "./app.tsx";
import "./styles.css";

createRoot(document.getElementById("root")!).render(<App />);

// Lets the home-screen app open with no signal (public/sw.js; never caches /api).
// Only on the real https site, not the dev server or the one-page demo.
if ("serviceWorker" in navigator && location.protocol === "https:") {
  navigator.serviceWorker.register("/sw.js").catch(() => {});
}
